import { useMemo } from 'react';

import { useChartLocale } from 'components/charts/hooks/use-chart-locale';
import { createMetricFormatters } from 'views/playground/features/data-lab/utils/format-metric';

// Formats DataLab values with the same number locale as the chart axes.
export const useMetricFormatters = () => {
  const { locale } = useChartLocale();

  return useMemo(() => createMetricFormatters(locale), [locale]);
};
